export default "__VITE_ASSET__BShGkGyh__"